<template>
  <section class="embed-uk-map">
    <svg viewBox="0 0 730 898" xmlns="http://www.w3.org/2000/svg">
      <g class="map">
        <path
          d="m243.9 671.44-6.68-6.68c-1.73-1.73-1.73-4.53 0-6.26l43.19-43.19c.83-.83 1.3-1.96 1.3-3.13v-29.41c0-1.17-.47-2.3-1.3-3.13l-13.01-13.01c-1.73-1.73-1.73-4.53 0-6.26l3.79-3.79c.83-.83 1.3-1.96 1.3-3.13v-14.63c0-1.17-.47-2.3-1.3-3.13l-10.91-10.91c-1.73-1.73-1.73-4.53 0-6.26l12.65-12.65c.83-.83 1.3-1.96 1.3-3.13v-11.33c0-2.45 1.98-4.43 4.43-4.43h11.9c1.17 0 2.3-.47 3.13-1.3l30.4-30.4c.83-.83 1.3-1.96 1.3-3.13v-17.99c0-2.45-1.98-4.43-4.43-4.43h-9.83c-2.45 0-4.43-1.98-4.43-4.43 0-1.17.47-2.3 1.3-3.13 1.73-1.73 1.73-4.53 0-6.26l-1.5-1.5c-1.73-1.73-1.73-4.53 0-6.26l1.33-1.32c1.73-1.73 1.73-4.53 0-6.26l-9.08-9.09c-1.73-1.73-1.73-4.53 0-6.26l3.39-3.39c1.73-1.73 1.73-4.53 0-6.26l-27.73-27.73c-1.73-1.73-4.53-1.73-6.26 0l-4.77 4.77c-1.73 1.73-4.53 1.73-6.26 0l-21.29-21.28c-1.73-1.73-4.53-1.73-6.26 0l-6.1 6.1c-.83.83-1.96 1.3-3.13 1.3h-9.44c-1.17 0-2.3.47-3.13 1.3l-7.8 7.8c-1.73 1.73-4.53 1.73-6.26 0l-2.52-2.52c-1.73-1.73-4.53-1.73-6.26 0l-13.26 13.26c-.83.83-1.3 1.96-1.3 3.13v19.11c0 1.18-.47 2.3-1.3 3.13l-26.82 26.82c-.83.83-1.3 1.96-1.3 3.13v14.17c0 2.45-1.98 4.43-4.43 4.43h-14.61c-1.17 0-2.3-.47-3.13-1.3l-10.47-10.47c-.83-.83-1.96-1.3-3.13-1.3h-22.4c-1.18 0-2.3.47-3.13 1.3l-9.89 9.89c-.83.83-1.3 1.96-1.3 3.13v38.81c0 2.45-1.98 4.43-4.43 4.43h-13.33c-2.45 0-4.43 1.98-4.43 4.43v17.53c0 1.18.47 2.3 1.3 3.13l13.1 13.1c.83.83 1.96 1.3 3.13 1.3h15.15c1.18 0 2.3.47 3.13 1.3l9.58 9.58c.83.83 1.96 1.3 3.13 1.3h10.17c2.45 0 4.43 1.98 4.43 4.43v5.01c0 2.45-1.98 4.43-4.43 4.43h-16.43c-1.18 0-2.3.47-3.13 1.3l-14.56 14.55c-.83.83-1.3 1.96-1.3 3.13v20.04c0 2.45-1.98 4.43-4.43 4.43h-20.16c-1.18 0-2.3.47-3.13 1.3l-14.45 14.45c-.83.83-1.96 1.3-3.13 1.3h-10.54c-1.17 0-2.3.47-3.13 1.3l-7.32 7.32c-1.73 1.73-1.73 4.53 0 6.26.83.83 1.96 1.3 3.13 1.3h28.4c1.18 0 2.3.47 3.13 1.3l1.87 1.87c1.73 1.73 1.73 4.53 0 6.26l-8.06 8.06c-.83.83-1.96 1.3-3.13 1.3h-23.34c-2.44 0-4.42 1.98-4.43 4.42v6.47c0 2.45 1.98 4.43 4.43 4.43h.25l1.44-.08c2.44-.14 4.54 1.73 4.67 4.17v.25 11.11c0 2.45 1.98 4.43 4.43 4.43 1.17 0 2.3-.47 3.13-1.3l2.65-2.65c.83-.83 1.96-1.3 3.13-1.3h17.18c2.45 0 4.43 1.98 4.43 4.43v19.91c0 2.45 1.98 4.43 4.43 4.43h43.75c1.17 0 2.3-.47 3.13-1.3l14.6-14.6c.83-.83 1.96-1.3 3.13-1.3h35.89c1.17 0 2.3-.47 3.13-1.3l12.4-12.4c.83-.83 1.96-1.3 3.13-1.3h33.56c1.18 0 2.3.47 3.13 1.3l11.9 11.9c.83.83 1.96 1.3 3.13 1.3h18.87c2.45 0 4.43-1.98 4.43-4.43 0-1.17-.47-2.3-1.3-3.13"
        />
        <path
          d="m728.7 663.32-21.78-21.78c-.45-.45-1.05-.7-1.69-.7h-44.12c-.63 0-1.24.25-1.69.7l-13.49 13.49c-.93.93-2.44.93-3.38 0l-10.59-10.59c-.93-.93-.93-2.44 0-3.38s13.14-13.15 13.14-13.15c.45-.45.7-1.05.7-1.69v-23.89c0-.63-.25-1.24-.7-1.69l-30.95-30.95c-.93-.93-.93-2.44 0-3.38l1.55-1.55c.93-.93 2.44-.93 3.38 0l10.6 10.6c.45.45 1.05.7 1.69.7h12.47c1.32 0 2.39-1.07 2.39-2.39v-25.81c0-.63-.25-1.24-.7-1.69l-15.62-15.63c-.45-.45-.7-1.05-.7-1.69v-12.02c0-.63-.25-1.24-.7-1.69l-26.67-26.67v-14.4c0-1.09-.43-2.13-1.2-2.89l-18-18c-.77-.77-1.2-1.81-1.2-2.89v-30.08c0-1.09-.43-2.13-1.2-2.89l-8.59-8.59c-1.33-1.33-2.08-3.13-2.08-5.01v-44.27c0-.73-.29-1.42-.8-1.94l-43.77-43.77c-1.07-1.07-2.81-1.07-3.88 0l-10.37 10.37c-1.07 1.07-2.81 1.07-3.88 0l-8.65-8.65c-.52-.51-1.21-.8-1.94-.8h-14.1c-.73 0-1.43-.29-1.94-.8l-6.6-6.6c-1.07-1.07-1.07-2.81 0-3.88.51-.51 1.21-.8 1.94-.8h39.7c.73 0 1.42-.29 1.94-.8l11.27-11.27c1.07-1.07 1.07-2.81 0-3.88l-13.8-13.8c-.52-.51-1.21-.8-1.94-.8h-17.3c-1.51 0-2.74-1.23-2.74-2.74 0 0 0-.01 0-.02v-3.21c0-1.51 1.23-2.74 2.74-2.74h39.63c.73 0 1.42-.29 1.94-.8l18.31-18.31c.51-.52.8-1.21.8-1.94v-11.49c0-.73.29-1.42.8-1.94l10.4-10.4c.51-.52.8-1.21.8-1.94v-13.87c0-.73.29-1.42.8-1.94l7.35-7.35c.51-.52.8-1.21.8-1.94v-18.01c0-.73-.29-1.42-.8-1.94l-22.36-22.37c-.52-.51-1.21-.8-1.94-.8h-30.07c-1.52 0-2.74-1.23-2.74-2.74 0-.73.29-1.42.8-1.94l5.92-5.92c1.07-1.07 1.07-2.81 0-3.88-.51-.51-1.21-.8-1.94-.8h-21.21c-.73 0-1.42.29-1.94.8l-12.16 12.16c-1.07 1.07-2.81 1.07-3.88 0l-2.63-2.63c-1.07-1.07-1.07-2.81 0-3.88l13.64-13.64c1.07-1.07 1.07-2.81 0-3.88-.51-.51-1.21-.8-1.94-.8h-1.84c-1.52 0-2.74-1.23-2.74-2.74 0-.73.29-1.42.8-1.94l46.11-46.11c.51-.52.8-1.21.8-1.94v-34.9c0-1.52 1.23-2.74 2.74-2.74.73 0 1.42.29 1.94.8l2.5 2.5c.51.52.8 1.21.8 1.94v9.56c0 1.52 1.23 2.74 2.74 2.74.73 0 1.43-.29 1.94-.8l8.88-8.88c.51-.52.8-1.21.8-1.94v-20.3c0-1.51-1.23-2.74-2.74-2.74h-16.39c-.73 0-1.42-.29-1.94-.8l-11.72-11.73c-1.07-1.07-2.81-1.07-3.88 0-.51.51-.8 1.21-.8 1.94v20.07c0 1.51-1.23 2.74-2.74 2.74h-9.03c-1.51 0-2.74 1.23-2.74 2.74 0 .73.29 1.43.8 1.94l14.78 14.78c1.07 1.07 1.07 2.81 0 3.88l-4.13 4.13c-.52.51-1.21.8-1.94.8h-13.41c-.73 0-1.42-.29-1.94-.8l-13.56-13.56c-.51-.51-1.21-.8-1.94-.8h-53.47c-1.51 0-2.74 1.23-2.74 2.74v8.17c0 .73-.29 1.42-.8 1.94l-20.84 20.84c-1.07 1.07-1.07 2.81 0 3.88l4.22 4.22c1.07 1.07 1.07 2.81 0 3.88l-30.27 30.26c-1.07 1.07-1.07 2.81 0 3.88l8.87 8.87c1.07 1.07 1.07 2.81 0 3.88l-3.54 3.54c-1.07 1.07-2.81 1.07-3.88 0l-.38-.38c-1.07-1.07-2.81-1.07-3.88 0-.51.51-.8 1.21-.8 1.94v8.91c0 .73.29 1.42.8 1.94l6.58 6.58c1.07 1.07 1.07 2.81 0 3.88l-10.39 10.38c-1.07 1.07-2.81 1.07-3.88 0l-10.5-10.5c-1.07-1.07-1.07-2.81 0-3.88l2.47-2.47c1.07-1.07 1.07-2.81 0-3.88-.51-.51-1.21-.8-1.94-.8h-2.5c-1.51 0-2.74-1.23-2.74-2.74v-18.01c0-1.51-1.23-2.74-2.74-2.74-.73 0-1.43.29-1.94.8-.52.51-1.21.8-1.94.8h-15.97c-.73 0-1.42.29-1.94.8l-9.84 9.84c-1.07 1.07-1.07 2.81 0 3.88l34.02 34.01c1.07 1.07 1.07 2.81 0 3.88l-11.38 11.38c-1.07 1.07-1.07 2.81 0 3.88.51.51 1.21.8 1.94.8h10.12c1.52 0 2.74 1.23 2.74 2.74 0 .73-.29 1.42-.8 1.94l-8.72 8.72c-.52.51-1.21.8-1.94.8h-16.67c-1.52 0-2.74 1.23-2.74 2.74 0 .73.29 1.42.8 1.94l8.16 8.16c.52.51 1.21.8 1.94.8h12.19c1.51 0 2.74 1.23 2.74 2.74 0 .73-.29 1.43-.8 1.94l-.5.5c-1.07 1.07-1.07 2.81 0 3.88l19.34 19.34c1.07 1.07 1.07 2.81 0 3.88l-3.64 3.64c-.51.52-.8 1.21-.8 1.94v25.2c0 1.52-1.23 2.74-2.74 2.74h-7.12c-1.52 0-2.74-1.23-2.74-2.74v-19.8c0-1.51-1.23-2.74-2.74-2.74-.73 0-1.43.29-1.94.8l-14.78 14.79c-.51.52-.8 1.21-.8 1.94v7.36c0 1.51-1.23 2.74-2.74 2.74h-19.02c-1.52 0-2.74 1.23-2.74 2.74v12.27c0 .73.29 1.42.8 1.94l3.6 3.6c1.07 1.07 1.07 2.81 0 3.88l-9.46 9.46c-1.07 1.07-1.07 2.81 0 3.88l14.34 14.34c1.07 1.07 2.81 1.07 3.88 0l14.79-14.79c.51-.52.8-1.21.8-1.94v-8.08c0-.73.29-1.43.8-1.94l6.33-6.33c.52-.51 1.21-.8 1.94-.8h3.82c1.52 0 2.74 1.23 2.74 2.74v15.44c0 .73-.29 1.42-.8 1.94l-14.5 14.5c-1.07 1.07-1.07 2.81 0 3.88l4.06 4.06c1.07 1.07 2.81 1.07 3.88 0l25.08-25.08c.51-.52.8-1.21.8-1.94v-17.14c0-1.52 1.23-2.74 2.74-2.74h14.3c.73 0 1.42-.29 1.94-.8l10.64-10.64c1.07-1.07 2.81-1.07 3.88 0l2.12 2.12c1.07 1.07 1.07 2.81 0 3.88l-24.31 24.31c-2.22 2.22-2.22 5.82 0 8.04l24.9 24.9c1.07 1.07 1.07 2.81 0 3.88l-35.45 35.45c-1.89 1.89-1.89 4.96 0 6.85l15.73 15.74c1.89 1.89 4.96 1.89 6.85 0 1.89-1.89 4.96-1.89 6.85 0l14.27 14.27c1.89 1.89 4.96 1.89 6.85 0l15.02-15.02c1.89-1.89 4.96-1.89 6.85 0l6.88 6.88c1.89 1.89 1.89 4.96 0 6.85l-8.13 8.13c-.91.91-1.42 2.14-1.42 3.42v38.32c0 1.28.5 2.5 1.4 3.41l8.15 8.23c1.88 1.89 1.87 4.95-.02 6.83l-2.64 2.64c-1.89 1.89-1.89 4.96 0 6.85l1.81 1.81c2.82 2.82 7.4 2.82 10.22 0l5.7-5.7c.91-.91 2.14-1.42 3.42-1.42h10.5c1.37 0 2.48 1.11 2.48 2.48v19.09c0 1.32-1.07 2.39-2.39 2.39h-6.51c-.63 0-1.24.25-1.69.7l-3.84 3.84c-.45.45-.7 1.05-.7 1.69v20.22c0 .63.25 1.24.7 1.69l6.55 6.55c.45.45.7 1.05.7 1.69v32.46c0 1.32-1.07 2.39-2.39 2.39h-22.12c-1.32 0-2.39-1.07-2.39-2.39v-10.52c0-1.32-1.07-2.39-2.39-2.39h-35.83c-.63 0-1.24.25-1.69.7l-12.51 12.51c-.45.45-1.05.7-1.69.7h-8.5c-1.32 0-2.39-1.07-2.39-2.39v-4.59c0-.63.25-1.24.7-1.69l11.63-11.63c.45-.45.7-1.05.7-1.69v-12.65c0-1.32-1.07-2.39-2.39-2.39h-28.59c-.63 0-1.24.25-1.69.7l-6.49 6.49c-.93.93-.93 2.44 0 3.38l11.18 11.18c.45.45.7 1.05.7 1.69v12c0 .63-.25 1.24-.7 1.69l-20.38 20.38c-.93.93-.93 2.44 0 3.38.45.45 1.06.7 1.69.7h9.3c.63 0 1.24.25 1.69.7l9.61 9.61c.93.93 2.44.93 3.37 0s7.96-7.96 7.96-7.96c.45-.45.7-1.05.7-1.69v-3.29c0-1.32 1.07-2.39 2.39-2.39h7.07c1.32 0 2.39 1.07 2.39 2.39v13.98c0 .63-.25 1.24-.7 1.69l-11.98 11.98c-.93.93-.93 2.44 0 3.37s4.75 4.75 4.75 4.75c.93.93.93 2.44 0 3.38s-16.54 16.55-16.54 16.55c-.45.45-1.05.7-1.69.7h-28.2c-.63 0-1.24.25-1.69.7l-31.2 31.2c-.45.45-.7 1.05-.7 1.69v13.99c0 1.32 1.07 2.39 2.39 2.39h12.03c1.32 0 2.39 1.07 2.39 2.39v5.8c0 .63.25 1.24.7 1.69l3.51 3.51c.93.93 2.44.93 3.38 0s14.94-14.94 14.94-14.94c.93-.93 2.44-.93 3.38 0s11.55 11.55 11.55 11.55c.45.45 1.05.7 1.69.7h12.16c.63 0 1.24.25 1.69.7l38.41 38.41c2 2 5.25 2 7.25 0s10.82-10.82 10.82-10.82c.45-.45 1.05-.7 1.69-.7h12.85c1.32 0 2.39 1.07 2.39 2.39 0 .63-.25 1.24-.7 1.69l-19.13 19.14c-.96.96-2.27 1.5-3.63 1.5h-12.55c-3.41 0-6.68-1.35-9.09-3.76l-2.99-2.99c-2.41-2.41-5.68-3.76-9.09-3.76h-22.28c-2.05 0-4.01.81-5.46 2.26l-15.42 15.42c-1.45 1.45-3.41 2.26-5.46 2.26h-7.26c-4.26 0-7.72 3.46-7.72 7.72v19.12c0 2.05-.81 4.01-2.26 5.46l-20.67 20.67c-1.45 1.45-3.41 2.26-5.46 2.26h-9c-2.05 0-4.01.81-5.46 2.26l-10.66 10.66c-1.45 1.45-3.41 2.26-5.46 2.26h-14.69c-2.05 0-4.01.81-5.46 2.26l-9.17 9.17c-1.45 1.45-2.26 3.41-2.26 5.46v4.16c0 1.97 1.59 3.56 3.56 3.56h17.36c2.05 0 4.01.81 5.46 2.26l.85.85c1.45 1.45 3.41 2.26 5.46 2.26h7.93c4.26 0 7.72-3.46 7.72-7.72v-.67c0-4.26 3.46-7.72 7.72-7.72h11.74c2.05 0 4.01-.81 5.46-2.26l8.47-8.47c1.45-1.45 3.41-2.26 5.46-2.26h20.49c2.05 0 4.01.81 5.46 2.26l12.3 12.3c3.02 3.02 7.9 3.02 10.92 0s31.49-31.49 31.49-31.49c2.41-2.41 5.68-3.76 9.09-3.76h19.2c1.36 0 2.66.54 3.63 1.5l17.4 17.4c2 2 5.25 2 7.25 0 2-2 5.25-2 7.25 0s2.36 2.36 2.36 2.36c.96.96 2.27 1.5 3.63 1.5h10.55c2.83 0 5.13-2.29 5.13-5.13v-4.52c0-2.83 2.3-5.13 5.13-5.13h28c1.36 0 2.66-.54 3.62-1.5l2.5-2.5c2-2 5.25-2 7.25 0l8.43 8.43c.96.96 2.27 1.5 3.63 1.5h21.16c1.36 0 2.66.54 3.63 1.5l9.29 9.29c1.11 1.11 2.62 1.74 4.2 1.74h25.66c1.58 0 3.09-.63 4.2-1.74l21.8-21.8c1.11-1.11 2.62-1.74 4.2-1.74h16.95c1.58 0 3.09-.63 4.2-1.74l22.65-22.65c1.71-1.71 2.67-4.03 2.67-6.45v-7.6c0-3.16-2.56-5.73-5.73-5.73h-45.31c-3.28 0-5.95-2.66-5.95-5.95s2.66-5.95 5.95-5.95h21.2c1.58 0 3.09-.63 4.2-1.74l30.5-30.5c.6-.6.94-1.42.94-2.27v-2.18c0-1.32-1.07-2.39-2.39-2.39-1.32 0-2.38-1.07-2.38-2.38v-2.59c0-1.32 1.07-2.39 2.39-2.39h11.59c.63 0 1.24-.25 1.69-.7l18.68-18.68c.45-.45.7-1.05.7-1.69v-60.23c0-.63-.25-1.24-.7-1.69"
        />
        <path
          d="m315.85 97.9c.14.71.48 1.36.99 1.87l14.35 14.42c1.41 1.42 3.7 1.42 5.12.01l15.79-15.79c.68-.68 1.6-1.06 2.56-1.06h6.73c2 0 3.62-1.62 3.62-3.62v-11.56c0-.96.38-1.88 1.06-2.56l16.84-16.84c.68-.68 1.06-1.6 1.06-2.56v-12.66c0-2-1.62-3.62-3.62-3.62h-24.56c-.96 0-1.88.38-2.56 1.06l-38.51 38.52c-.85.85-1.22 2.06-1 3.24z"
        />
      </g>
      <text class="name color4" transform="translate(350 140)">
        Highlands
      </text>
      <circle cx="418" cy="105" class="color4" r="9.93" />
      <text class="name color3" transform="translate(438.78 578.68)">
        Lancashire
      </text>
      <circle cx="499.08" cy="543.6" class="color3" r="9.93" />
      <foreignObject x="288" y="380" width="400" height="200">
        <div
          :class="[
            'bubble color2',
            chester ? 'opacity-100 active' : 'opacity-0'
          ]"
        >
          <span class="paragraph">
            Chester has been home to the Grosvenor family since the 1400s,
            specifically the Eaton Estate located on the outskirts of the city.
            The Estate manages and works to improve a range of agricultural,
            residential and commercial properties with tailored tenancies in
            rural Cheshire and the city of Chester.
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="150.98"
            height="21.251"
            viewBox="0 0 150.98 21.251"
            class="bubble__tail"
          >
            <path
              d="M9040.518-3518.848a23.611,23.611,0,0,1,15.094,5.445l16.653,13.847a8.509,8.509,0,0,0,10.863,0l16.655-13.848a23.611,23.611,0,0,1,15.092-5.444Z"
              transform="translate(-9004.321 3518.848)"
            />
          </svg>
        </div>
      </foreignObject>
      <text class="name color2" transform="translate(439.61 652)">
        Chester
      </text>
      <circle
        @click="chester = !chester"
        class="dot color2"
        :class="!chester ? 'animate--enlarge' : null"
        cx="485.13"
        cy="616.92"
        r="9.93"
      />
      <foreignObject x="422" y="560" width="400" height="200">
        <div
          :class="[
            'bubble color1',
            westminster ? 'opacity-100 active' : 'opacity-0'
          ]"
        >
          <span class="paragraph">
            The Grosvenor family's association with London property began over
            300 years ago through the development of Mayfair in the 1720s and
            Belgravia a hundred years later. Today, the Grosvenor name
            represents one of the world's largest privately-owned international
            property companies, headquartered in Westminster.
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="150.98"
            height="21.251"
            viewBox="0 0 150.98 21.251"
            class="bubble__tail"
          >
            <path
              d="M9040.518-3518.848a23.611,23.611,0,0,1,15.094,5.445l16.653,13.847a8.509,8.509,0,0,0,10.863,0l16.655-13.848a23.611,23.611,0,0,1,15.092-5.444Z"
              transform="translate(-9004.321 3518.848)"
            />
          </svg>
        </div>
      </foreignObject>
      <text class="name color1" transform="translate(541.17 833.51)">
        Westminster
      </text>
      <circle
        @click="westminster = !westminster"
        style="animation-delay: 250ms"
        class="dot color1"
        :class="!westminster ? 'animate--enlarge' : null"
        cx="620"
        cy="800"
        r="9.93"
      />
    </svg>
  </section>
</template>

<script>
export default {
  name: 'EmbedUKMap',
  data: () => {
    return {
      chester: false,
      westminster: false
    };
  }
};
</script>

<style lang="postcss">
.color1 {
  fill: #ff5c35;
  background-color: #ff5c35;
}
.color2 {
  fill: #5e6eff;
  background-color: #5e6eff;
}
.color3 {
  fill: #0e7853;
}
.color4 {
  fill: #ffadc5;
}

@keyframes enlarge {
  0% {
    transform: scale3d(0.9, 0.9, 0.9);
  }
  100% {
    transform: scale3d(1.1, 1.1, 1.1);
  }
}

.animate--enlarge {
  animation-name: enlarge;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
  animation-timing-function: cubic-bezier(0.65, 0, 0.35, 1);
  animation-direction: alternate-reverse;
}

.embed-uk-map {
  width: 100%;
  .map {
    fill: #fff;
  }

  padding: 5%;
  position: relative;
  svg {
    overflow: visible;
    .dot {
      @apply pointer-events-auto;
      @apply cursor-pointer;
      transition-duration: 500ms;
      transition-property: transform;
      transition-timing-function: cubic-bezier(0.33, 1, 0.68, 1);
      transform: scale3d(1, 1, 1);
      transform-origin: center;
      transform-box: fill-box;
      z-index: 1;

      &:hover {
        transform: scale3d(1.2, 1.2, 1.2);
        animation-play-state: paused;
        animation-iteration-count: 2;
      }
    }
  }

  foreignObject {
    overflow: visible;
    pointer-events: none;
  }

  .bubble {
    z-index: 0;
    pointer-events: none;
    position: relative;
    transition-duration: 500ms;
    transition-property: transform, opacity;
    transition-timing-function: cubic-bezier(0.33, 1, 0.68, 1);
    transform: 3d (0.75, 0.75, 0.75);
    transform-origin: center;
    transform-box: fill-box;
    border-radius: 4px;
    width: 100%;
    height: 100%;
    &.active {
      position: relative;
      transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1);
      pointer-events: auto;
      z-index: 2;
    }
  }
  .bubble__tail {
    position: absolute;
    bottom: -20px;
    left: 0;
    right: 0;
    margin: auto;
  }

  .name {
    font-family: GintoNormal-Black, sans-serif;
    font-size: 26px;
  }

  .paragraph {
    font-family: GintoNormal, sans-serif;
    font-size: 14px;
    color: #fff;
    position: absolute;
    padding: 20px;
    text-align: center;
    z-index: 1;
  }
}

.block-embed__component__object {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
